import { useState } from "react";
import { useLang } from "../../../core/lang";
import LangKeys from "../../../core/locales/keys";

function BankDetailsPage({ setActivePage }) {
  const { t } = useLang();

  const cached = JSON.parse(localStorage.getItem("business_profile") || "null");

  const [bankName, setBankName] = useState(cached?.bank_name || "");
  const [accountNumber, setAccountNumber] = useState(cached?.account_number || "");
  const [ifsc, setIfsc] = useState(cached?.ifsc_code || "");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  const save = async () => {
    const bank = bankName.trim();
    const acc = accountNumber.trim();
    const code = ifsc.trim().toUpperCase();

    if (!bank || !acc || code.length !== 11) {
      setError(t(LangKeys.invalid_bank_details));
      return;
    }

    try {
      setSaving(true);
      setError("");

      const token = localStorage.getItem("token");

      const res = await fetch(
        "https://khata.moxpal.com/api/v2/index.php/business-profile/bank",
        {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({
            bank_name: bank,
            account_number: acc,
            ifsc_code: code,
          }),
        }
      );

      const data = await res.json();

      if (!data?.success) {
        throw new Error(data?.error?.message || t(LangKeys.failed_to_save));
      }

      const updated = {
        ...(cached || {}),
        bank_name: bank,
        account_number: acc,
        ifsc_code: code,
      };

      localStorage.setItem("business_profile", JSON.stringify(updated));
      setActivePage(null);
    } catch (err) {
      setError(err.message || t(LangKeys.failed_to_save));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.header}>
        <button style={styles.backBtn} onClick={() => setActivePage(null)}>
          ←
        </button>
        <h2 style={styles.title}>{t(LangKeys.bank_details)}</h2>
      </div>

      <div style={styles.card}>
        <div style={styles.label}>{t(LangKeys.bank_name)}</div>
        <input
          type="text"
          value={bankName}
          onChange={(e) => setBankName(e.target.value)}
          placeholder={t(LangKeys.enter_bank_name)}
          style={styles.input}
        />

        <div style={styles.label}>{t(LangKeys.account_number)}</div>
        <input
          type="text"
          value={accountNumber}
          onChange={(e) => setAccountNumber(e.target.value)}
          placeholder={t(LangKeys.enter_account_no)}
          style={styles.input}
        />

        <div style={styles.label}>{t(LangKeys.ifsc_code)}</div>
        <input
          type="text"
          value={ifsc}
          maxLength={11}
          onChange={(e) => setIfsc(e.target.value.toUpperCase())}
          placeholder={t(LangKeys.enter_ifsc)}
          style={styles.input}
        />

        <div style={styles.note}>{t(LangKeys.bank_note)}</div>

        {error ? <div style={styles.error}>{error}</div> : null}

        <button
          style={{
            ...styles.saveBtn,
            ...(saving ? styles.saveBtnDisabled : {}),
          }}
          onClick={save}
          disabled={saving}
        >
          {saving ? t(LangKeys.saving) : t(LangKeys.save_bank_details)}
        </button>
      </div>
    </div>
  );
}

const styles = {
  page: {
    padding: "16px",
  },

  header: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "16px",
  },

  backBtn: {
    width: "40px",
    height: "40px",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    background: "#fff",
    cursor: "pointer",
    fontSize: "20px",
  },

  title: {
    fontSize: "20px",
    fontWeight: "700",
    color: "#111827",
    margin: 0,
  },

  card: {
    background: "#fff",
    borderRadius: "20px",
    padding: "24px",
    border: "1px solid #E5E7EB",
    maxWidth: "620px",
  },

  label: {
    fontSize: "14px",
    fontWeight: "600",
    color: "#374151",
    marginBottom: "8px",
    marginTop: "2px",
  },

  input: {
    width: "100%",
    height: "50px",
    borderRadius: "12px",
    border: "1px solid #E5E7EB",
    padding: "0 14px",
    fontSize: "15px",
    outline: "none",
    boxSizing: "border-box",
    marginBottom: "14px",
  },

  note: {
    fontSize: "12px",
    color: "#6B7280",
    lineHeight: "18px",
    marginTop: "2px",
  },

  error: {
    marginTop: "12px",
    fontSize: "13px",
    color: "#DC2626",
    fontWeight: "500",
  },

  saveBtn: {
    width: "100%",
    height: "48px",
    border: "none",
    borderRadius: "14px",
    background: "#2563EB",
    color: "#fff",
    fontWeight: "700",
    cursor: "pointer",
    marginTop: "18px",
  },

  saveBtnDisabled: {
    opacity: 0.7,
    cursor: "not-allowed",
  },
};

export default BankDetailsPage;